// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import LotteryItemBase from "../common/LotteryItemBase";
import { HappyWinKind } from "./data/HappyWinKind";

const {ccclass, property} = cc._decorator;


@ccclass
export default class HappyWinItemBase extends LotteryItemBase {


    @property(cc.Label)
    labelCard: cc.Label = null;
   
    private cardData: number = 0;
    // onLoad () {}

    start () {
        this.initUI();
    }

    setData(
        cardData: number
    ) {
        this.resetData();
        this.cardData = cardData;
        if (this.isInit()) {
            this.initUI();
        }
    }

    resetData() {
        this.bOpenShow = false;
        let children = this.judgeNode.children;
        for(let i = children.length-1; i >= 0; i--) {
            let nodeItem = children[i];
            nodeItem.active = true;
        }
    }

    initUI() {
        let card = this.cardData;
        let idx = card - HappyWinKind.GeneralValue.SpaceValue;
        this.labelCard.string = HappyWinKind.CardData[idx] + '';
    }

    // update (dt) {}
}
